var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('masonry',{attrs:{"cols":{ default: 9, 1280: 8, 1024: 6, 800: 5, 600: 3 },"gutter":20}},_vm._l((_vm.openedFolder),function(item,index){return _c('Item',{key:index,attrs:{"file":item},on:{"after-delete":function($event){return _vm.openedFolder.splice(index, 1)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }